export default __webpack_public_path__ + "static/media/message.ab086eb8.png";